<template>
    <div class="ds-single-select-group p-2 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-ds-primary-200">
        <div class="ds-single-select-group-label px-3 py-1">
            <p class="text-content-md font-semibold text-content-secondary">{{ label }}</p>
        </div>
        <div class="ds-single-select-group-items">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts" generic="T">
import type { DsSingleSelectGroup } from './single-select.types';

defineProps<DsSingleSelectGroup<T>>();
</script>
